import styles from "./notificationDetails.module.css";
import { Link, useParams } from "react-router-dom";
import Helmet from "react-helmet";
import Footer from "../../components/Footer";
import { Typography } from "@mui/material";
import { ArrowLeft, Home } from "react-feather";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from "../../components/Loader";
import { useState, useEffect } from "react";
import axios from "axios";
import { TableLoaderSmall } from "../../components/LoaderC";

const NotificationDetails = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { id } = useParams();
  const [contentLoading, setContentLoading] = useState(true);
  const [allData, setAllData] = useState(null);

  useEffect(() => {
    const getCampaignPreview = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_USER_API_URL + "v1/email-sms-contents/" + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch(() => {
        setContentLoading(false);
      });
    };

    if (id) {
      getCampaignPreview();
    }
  }, [getAccessTokenSilently, id]);

  return (<>
    <Helmet title="Preview Notification" />

    <div className={`${styles.mainCard}`}>
      <div className={`${styles.SMProCusRow}`}>
        <div className={`${styles.BreadcrumbHeadSec}`}>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Notification</li>
              <li className={`${styles.breadcrumbItem}`}>
                <Link to={"/notification/email-sms-notification"}>Manage notification</Link>
              </li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>Preview {allData?.category}</li>
            </ol>
          </nav>
          <div className={`${styles.PageTitleSec}`}>
            <div>
              <Link to={`/notification/email-sms-notification`} className={`${styles.BackArrow}`}>
                <ArrowLeft />
              </Link>
              <Typography display="inline" className={`${styles.pageTitle}`}>Preview {allData?.category}</Typography>
            </div>
          </div>
        </div>

        {contentLoading && (<div className="Loader TableLoader">
          <TableLoaderSmall />
        </div>)}

        {!contentLoading && <div className={`${styles.mainCardUnder}`}>

          <div className={`${styles.TemMain}`}>
            <table className={`${styles.TemMainTable}`}>
              <tbody>
                <tr>
                  <td className={`${styles.TemMainBorder}`}></td>
                </tr>
                <tr>
                  <td><img className={`${styles.TemLogo}`} src="https://propertydek.com/static/img/logo.svg" alt="" /></td>
                </tr>
                <tr>
                  <td>
                    <div className={`${styles.TemBody}`}>
                      <div dangerouslySetInnerHTML={{ __html: allData?.content }} />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className={`${styles.TemFoot}`}>
            <img className={`${styles.FootLogo}`} src="https://propertydek.com/static/img/logo.svg" alt="" />
            <p className={`${styles.TemFootText}`}><a href="mailto:info@thewestonhall.com">info@thewestonhall.com</a></p>
            <p className={`${styles.TemFootText}`}><a href="tel:3137778088">313-777-8088</a></p>
            <p className={`${styles.TemFootText2}`}>2211 Pingree Street Detroit, MI 48206</p>
            <div className={`${styles.AppLinkSec}`}>
              <a href="https://play.google.com/store/apps/details?id=com.propertydek.ionicapp">
                <img src="/static/img/playstore.png" height="20px" alt="" />
              </a>
              <a href="https://apps.apple.com/app/PropertyDek/id1661119081">
                <img src="/static/img/apple-logo.png" height="20px" alt="" />
              </a>
            </div>
            <p className={`${styles.TemFootText}`}><a href="https://propertydek.com/">PropertyDek</a> © 2024. All rights reserved.</p>
          </div>

        </div>}

      </div>
    </div>

    <Footer />
  </>)
}

export default withAuthenticationRequired(NotificationDetails, {
  onRedirecting: () => <Loader />,
});